import { createContext, useContext, useMemo, useCallback } from 'react';
import { useAppDataContext } from './AppDataContext';
import { deriveProductsFromBottles, applyProductsDeltaToBottles } from '../utils/bottleHelpers';

const ProductsContext = createContext(null);

export function ProductsProvider({ children }) {
  const { bottles, setBottles, skuMap } = useAppDataContext();

  const bjProducts = useMemo(
    () => deriveProductsFromBottles(bottles, skuMap, 'BJ'),
    [bottles, skuMap]
  );

  const marucoProducts = useMemo(
    () => deriveProductsFromBottles(bottles, skuMap, 'MARUCO'),
    [bottles, skuMap]
  );

  const updateBrandProducts = useCallback((brand, updater) => {
    setBottles(prev => {
      const current = deriveProductsFromBottles(prev, skuMap, brand);
      const next = typeof updater === 'function' ? updater(current) : updater;
      return applyProductsDeltaToBottles(prev, current, next, brand);
    });
  }, [setBottles, skuMap]);

  const setBjProducts = useCallback(
    (updater) => updateBrandProducts('BJ', updater),
    [updateBrandProducts]
  );

  const setMarucoProducts = useCallback(
    (updater) => updateBrandProducts('MARUCO', updater),
    [updateBrandProducts]
  );

  return (
    <ProductsContext.Provider value={{ bjProducts, marucoProducts, setBjProducts, setMarucoProducts }}>
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  const ctx = useContext(ProductsContext);
  if (!ctx) throw new Error('useProducts must be used within ProductsProvider');
  return ctx;
}
